import classNames from 'classnames';
import { FC, Fragment } from 'react';
import styles from './per-year-capital-structure-chart.module.scss';
import { NET_DEBT_RANK } from '../../pwerm2-widgets/total-equity/constants';
import {
  PerYearCapitalStructureChartInstrument,
  PerYearCapitalStructureChartStructure,
} from './per-year-capital-structure-chart-types';

interface PerYearCapitalStructureChartInstrumentStackProps {
  structure: PerYearCapitalStructureChartStructure;
  isExpanded: boolean;
  instrumentBlockRenderer: (
    instrument: PerYearCapitalStructureChartInstrument,
    index: number
  ) => JSX.Element;
}

export const PerYearCapitalStructureChartInstrumentStack: FC<
  PerYearCapitalStructureChartInstrumentStackProps
> = ({ structure, isExpanded, instrumentBlockRenderer }) => (
  <>
    {structure.ranks
      .filter((rank) => rank.rank !== NET_DEBT_RANK)
      .sort((a, b) => b.rank - a.rank)
      .map((rank) => (
        <Fragment key={`instrument-${rank.rank}`}>
          <div
            style={{ height: (rank.proportionOfProceeds ?? 0) * 100 + '%' }}
            className={classNames(styles['graph__rank-block'], {
              [styles['graph__rank-block--expanded']]: isExpanded,
            })}>
            {rank.instruments.map((instrument, i) => (
              <Fragment key={'instrument-block-component' + i + instrument.id}>
                {instrumentBlockRenderer(instrument, i)}
              </Fragment>
            ))}
          </div>
        </Fragment>
      ))}
  </>
);
